import { types } from 'mobx-state-tree'

const ShiftsList = types
  .model('OrdersList', {
    searchFilters: types.model({
      locationId: types.maybeNull(types.number),
      workCategoryId: types.maybeNull(types.number),
    }),
  })
  .actions(self => ({
    setLocationId(locationId: number | null) {
      self.searchFilters.locationId = locationId
    },
    setWorkCategoryId(workCategoryId: number | null) {
      self.searchFilters.workCategoryId = workCategoryId
    },
    reset() {
      self.searchFilters.locationId = null
      self.searchFilters.workCategoryId = null
    },
  }))
  .views(self => ({
    get activeFiltersCount() {
      return [self.searchFilters.locationId, self.searchFilters.workCategoryId].filter(value => Boolean(value)).length
    },
  }))

export const shiftsListStore = ShiftsList.create({
  searchFilters: {
    locationId: null,
    workCategoryId: null,
  },
})
